// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"5a75d6a0","239":"7189c772","453":"1b9b22d8","455":"127da6d1"}[chunkId] + ".chunk.js";
};